import Box from "@mui/material/Box";
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import { connect } from "react-redux";
import { styled } from "@mui/material/styles";
import useInterval from "../../utils/hooks/useInterval";
import { isArrayOfLength, isNumber } from "@pheaa/channels-component-library";

const IconAlert = props => {
	return (
		<SvgIcon fill="none" sx={{ height: "26px", marginTop: "5px", width: "26px" }} viewBox="0 0 26 26">
			<g clipPath="url(#clipPath)">
				<path d="M12.75 25C19.3774 25 24.75 19.6274 24.75 13C24.75 6.37258 19.3774 1 12.75 1C6.12258 1 0.75 6.37258 0.75 13C0.75 19.6274 6.12258 25 12.75 25Z" fill="#D71920" stroke="#D71920" strokeWidth="1.5" strokeMiterlimit="10" />
				<path fillRule="evenodd" clipRule="evenodd" d="M12.75 19C13.3 19 13.75 19.45 13.75 20C13.75 20.55 13.3 21 12.75 21C12.2 21 11.75 20.55 11.75 20C11.75 19.45 12.2 19 12.75 19Z" fill="white" />
				<path fillRule="evenodd" clipRule="evenodd" d="M12.75 17C12.2 17 11.75 16.68 11.75 16.29V5.71C11.75 5.32 12.2 5 12.75 5C13.3 5 13.75 5.32 13.75 5.71V16.3C13.75 16.69 13.3 17.01 12.75 17.01" fill="white" />
			</g>
			<defs>
				<clipPath id="clipPath">
					<rect width="25.5" height="25.5" fill="white" transform="translate(0 0.25)" />
				</clipPath>
			</defs>
		</SvgIcon>
	);
};

const IconInfo = props => {
	return (
		<SvgIcon fill="none" sx={{ height: "26px", marginTop: "5px", width: "26px" }} viewBox="0 0 26 26">
			<path d="M12.75 25C19.3774 25 24.75 19.6274 24.75 13C24.75 6.37258 19.3774 1 12.75 1C6.12258 1 0.75 6.37258 0.75 13C0.75 19.6274 6.12258 25 12.75 25Z" fill="#265DDA" stroke="#265DDA" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M14.58 19.42H11.25C10.84 19.42 10.5 19.08 10.5 18.67C10.5 18.26 10.84 17.92 11.25 17.92H12.17V10.25H11.25C10.84 10.25 10.5 9.91 10.5 9.5C10.5 9.09 10.84 8.75 11.25 8.75H12.92C13.33 8.75 13.67 9.09 13.67 9.5V17.92H14.59C15 17.92 15.34 18.26 15.34 18.67C15.34 19.08 15 19.42 14.59 19.42H14.58Z" fill="white" />
			<path d="M12.5 7.41C12.9584 7.41 13.33 7.0384 13.33 6.58C13.33 6.1216 12.9584 5.75 12.5 5.75C12.0416 5.75 11.67 6.1216 11.67 6.58C11.67 7.0384 12.0416 7.41 12.5 7.41Z" fill="white" />
		</SvgIcon>
	);
};

const AnnouncementContainer = styled(Box)(({ theme }) => ({
	borderBottom: `1px solid ${theme.palette.neutral.main}`,
	color: theme.palette.text.primary,
	marginBottom: "29px",
	"&:empty": {
		display: "none"
	}
}));

const AnnouncementBox = styled(Box)(({ theme }) => ({
	alignItems: "flex-start",
	borderTop: `1px solid ${theme.palette.neutral.main}`,
	display: "flex",
	padding: "15px 0"
}));

const Announcement = props => {

	const {
		beginOn,
		endOn,
		message,
		severity
	} = props;

	const [now, setNow] = React.useState(new Date().getTime());

	let beginOnEpoch = null;
	let endOnEpoch = null;
	let isTimeToDisplay = false;

	try {
		beginOnEpoch = new Date(beginOn).getTime();
		endOnEpoch = new Date(endOn).getTime();
	} catch (e) {
		console.log(`Invalid date/time for Announcement: ${e}`);
	}

	if (isNumber(beginOnEpoch) && isNumber(endOnEpoch)) {
		isTimeToDisplay = (beginOnEpoch < now && endOnEpoch > now);
	}

	useInterval(() => {
		setNow(new Date().getTime());
	}, 1000);

	return isTimeToDisplay && (
		<AnnouncementBox>
			{severity === "urgent" ? <IconAlert /> : <IconInfo />}
			<Typography
				dangerouslySetInnerHTML={{ __html: message }}
				sx={{
					flex: "1 1 auto",
					marginLeft: 2
				}}
			/>
		</AnnouncementBox>
	);
};

const Announcements = props => {

	let returnElem = null;

	const { appConfig } = props;
	const { announcements } = appConfig;
	const { enabled, list } = announcements;

	if (isArrayOfLength(list)) {
		returnElem = (
			<AnnouncementContainer>
				{
					list.map((listItem, i) => {
						return <Announcement {...listItem} key={i} />;
					})
				}
			</AnnouncementContainer>
		);
	}

	return enabled && returnElem;
};

const mapStateToProps = state => {
	return {
		appConfig: state.common.appConfig
	};
};

const mapDispatchToProps = dispatch => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Announcements);